import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { clone, cutString } from '../../../../common/utils';
import { globalData, ADD, EDIT, VIEW } from '../../../../common/common';
import { BorderColor } from '@material-ui/icons';
import EditPanel from '../Inputs/Panel/EditPanel';

const Root = styled(Box)({
    width: '800px',
    padding: '20px',
    '& .personTitle': {
        fontSize: '20px',
    },
    '& .dragDom': {
        minWidth: '110px',
        float: 'left',
        position: 'absolute',
        backgroundColor: '#fff',
        cursor: 'pointer',
        color: '#009CEE',
        border: '1px solid #009CEE',
        borderRadius: '50px',
        marginBottom: '8px',
        padding: '0 5px',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        KhtmlUserSelect: 'none',
    },
    '& .btn-wapper': {
        width: '100%',
        '& .btn': {
            marginRight: '20px',
        },
    },
    '& .itemsWapper': {
        width: '100%',
    },
    '& .item-wapper': {
        backgroundColor: '#fff',
        cursor: 'pointer',
        color: '#009CEE',
        border: '1px solid #009CEE',
        borderRadius: '50px',
        margin: '0 8px 8px 0',
        padding: '0 5px',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        KhtmlUserSelect: 'none',
    },
    '& .item-wapper:hover': {
        backgroundColor: '#009CEE',
        color: '#fff',
    },
    '& .itemWapperSelect': {
        padding: '10px 15px',
        cursor: 'pointer',
        backgroundColor: '#009CEE',
        color: '#fff',
    },
    '& .edit': {
        width: '14px',
        height: '14px',
        color: '#009CEE',
        cursor: 'pointer',
    },
    '& .edit:hover': {
        color: '#43D79E',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
})

class EstatePerson extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pList: [],
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
    }

    render() {
        const { pList } = this.state;
        const tableRowView = (row, index) => {
            if (row.exist === false) {
                return <TableRow key={index} role="checkbox">
                    <TableCell>{row['.CHO.N.']}</TableCell>
                    <TableCell>{row['.CHO.R.C.'] ? row['.CHO.R.C.'].replace(';', ' ') : ''}</TableCell>
                    <TableCell>{row['.CHO.AddrNPho'] ? row['.CHO.AddrNPho']['phone'] : ''}</TableCell>
                    <TableCell>
                        <Button variant="outlined" size="small" color="primary" onClick={e => this.handleAdd(e, row)}>add</Button>
                    </TableCell>
                </TableRow>
            }
        }
        return (
            <Root className="c">
                <div className="personTitle">Click saved person in the list to add to the form, or add a new person</div>
                <div className="line"></div>
                <Table stickyHeader className="table">
                    <TableHead>
                        <TableRow role="checkbox">
                            <TableCell>Name</TableCell>
                            <TableCell>Relation</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Operations</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {pList.map((row, index) => (
                            tableRowView(row, index)
                        ))}
                        {pList.length === 0 && (
                            <TableRow style={{ height: 300 }}>
                                <TableCell colSpan={12} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                {/* <div className="itemsWapper flow">
                    {pList.map((obj, index) => (
                        // <div id={index} key={index} className={"item-wapper c"} onClick={this.handleClick} title={obj[".CHO.N."]}>{cutString(obj[".CHO.N."], 11)}</div>
                        <div id={index} key={index} className={"item-wapper c"} onClick={this.handleClick} title={obj}>{obj}</div>
                    ))}
                </div> */}
                <div className="line"></div>
                <div className="btn-wapper h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    <Button variant="contained" color="primary" onClick={this.handleAdd}>add new person</Button>
                </div>
            </Root>
        )
    }
    //1.判断当前的index
    //2.根据当前的index获取content[index]的数据
    //3.比对plist和content[index]的数据
    //4.有相同的就设为true
    componentDidMount() {
        if (globalData.pListData) {
            const pList = this.checkExistingIdToArr();
            this.setState({
                pList
            })
        }
    }
    checkExistingIdToArr() {
        const { crtData } = this.props;
        let pList = clone(globalData.pListData);
        for (const obj of pList) {
            obj["exist"] = false;
        }
        if (crtData.length > 0) {
            for (const obj1 of pList) {
                for (const obj2 of crtData) {
                    if (obj1.id === obj2.id) {
                        obj1["exist"] = true;
                    }
                }
            }
        }
        return pList;
    }
    handleClick(e) {
        const index = e.target.id;
        if (index) {
            const { pList } = this.state;
            const dragData = pList[index];
            this.props.choosePerson(dragData);
        }
    }
    handleAdd(e, data = null) {
        if (data) {
            delete data.exist;
        }
        this.props.choosePerson(data);
    }
    handleCancel() {
        this.props.handleCancel();
    }
}

export default EstatePerson;